import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialDecreaseService = {
    list: async () => axios.post(`${API_URL}/material-decreases/list`).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/material-decreases/${id}`).then(({data}) => data).catch((err) => { throw err }),
    save: async (formData, id) => {
        if (id) {
            formData.append('_method', 'PUT');
            return axios.post(`${API_URL}/material-decreases/${id}`, formData).then(({data}) => data).catch((err) => { throw err })
        }

        return axios.post(API_URL + `/material-decreases`, formData).then(({data}) => data).catch((err) => { throw err })
    },
}

export default MaterialDecreaseService;
